import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { payoutService } from '../services/payout.service';
import type { PayoutFilters, RequestPayoutData } from '../types/payout.types';

export const PAYOUTS_KEY = ['seller', 'payouts'];

export function usePayouts(filters?: PayoutFilters) {
  return useQuery({
    queryKey: [...PAYOUTS_KEY, filters],
    queryFn: () => payoutService.getPayouts(filters),
  });
}

export function usePayout(id: string) {
  return useQuery({
    queryKey: [...PAYOUTS_KEY, id],
    queryFn: () => payoutService.getPayout(id),
    enabled: !!id,
  });
}

export function useRequestPayout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: RequestPayoutData) => payoutService.requestPayout(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PAYOUTS_KEY });
      // Also invalidate wallet balance since payout affects it
      queryClient.invalidateQueries({ queryKey: ['walletBalance'] });
    },
  });
}

export function useCancelPayout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => payoutService.cancelPayout(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PAYOUTS_KEY });
      queryClient.invalidateQueries({ queryKey: ['walletBalance'] });
    },
  });
}
